import React from 'react';

/**
 * Icono de cobertura/batería: usa el mismo color que el texto (currentColor),
 * sin el aspecto “negrita” de los SVG negros como <img>.
 */
export function SensorStatusIcon({ src }) {
    return (
        <span
            aria-hidden
            style={{
                display: 'inline-block',
                flexShrink: 0,
                width: '16px',
                height: '16px',
                marginLeft: '4px',
                verticalAlign: 'text-bottom',
                backgroundColor: 'currentColor',
                WebkitMaskImage: `url(${src})`,
                WebkitMaskSize: 'contain',
                WebkitMaskRepeat: 'no-repeat',
                WebkitMaskPosition: 'center',
                maskImage: `url(${src})`,
                maskSize: 'contain',
                maskRepeat: 'no-repeat',
                maskPosition: 'center'
            }}
        />
    );
}
